<div class="grid system-location-grid">
    <!-- <agm-map id='system-location-map' (mapClick)='positionClicked($event)' [latitude]='startUpLat' [longitude]='startUpLon' >
        <agm-marker *ngIf='homeMarker !== null' [latitude]='homeMarker.lat' [longitude]='homeMarker.lon' (dragEnd)='markerDragEnd($event)' [markerDraggable]='true'></agm-marker>
    </agm-map>
    <app-text-edit id='system-location-address' value='{{systemAddress}}' (enterClicked)='onConfirm()' (valueChanged)='onAddressChanged($event)'> -->
        <!-- {{trans('systems.labels.address')}}
    </app-text-edit> -->
    <div id='system-location-address-background' class="group-background"></div>
</div>